module.exports = __webpack_public_path__ + "static/media/kitchenPrep.ee38c1da.png";